import React, { useEffect } from 'react';

import BSpeedDial from './BSpeedDial';
import Avatar from '@material-ui/core/Avatar';


// eslint-disable-next-line
export default function (props) {

    const tempLog = (event) => {
        console.log(event);
    }

    const addActions = props.actions || [
        { icon: <Avatar />, name: 'Edit Profile', onClick: tempLog },
    ]

    useEffect(() => {

        // eslint-disable-next-line
    }, []);

    return (
        <>
            <BSpeedDial
                posname='bottom-left'
                actions={addActions}
                direction={"up"}
            />
        </>
    )
}
